import { iBisViewComponent } from '@dohu/ibis-common';
import { DomSanitizer } from '@angular/platform-browser';
import { DxListComponent } from 'devextreme-angular/ui/list';
import { ProxyService } from '../../../../service/proxy.service';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { PatientListService } from './patient-list.service';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'app-patient-list',
    templateUrl: './patient-list.component.html',
    styleUrls: ['patient-list.component.scss'],
})
export class PatientListComponent extends iBisViewComponent {

    @ViewChild('patientList') patientList: DxListComponent;
    public declare edit: PatientListService;
    constructor(public proxy: ProxyService, public sanitizer: DomSanitizer) {
        super(proxy.patientList, proxy.lg, proxy.iui, proxy.activatedRoute);
    }

    onPatientChange(event: any) {
        if (event.event && event.value) {
            this.edit.getPatientFiles(event.value)
            this.edit.getPatientFinishedAppointment(event.value)
        } else {
            this.edit.patientFiles = [];
            this.edit.consultations = []
        }
    }

    viewAppointment(data: any, ev: any) {
        if (ev) {
            ev.event.preventDefault();
            ev.event.stopPropagation();
        }
        this.proxy.calendar.viewAppointment(data)
    }


    downloadAppointment(data: any, ev: any) {
        if (ev) {
            ev.event.preventDefault();
            ev.event.stopPropagation();
        }
        this.proxy.calendar.downloadAppointment(data).then(
            () => { notify(this.proxy.ds.lg.format('FILES_DOWNLOADED', null), 'success', 2000); },
            () => { notify(this.proxy.ds.lg.format('DOWNLOAD_ERROR', null), 'error', 3000); });
    }

    addPatientFiles(data: any, ev: any) {
        this.proxy.file.upload(data.ap_id).then(() => {
            notify('Fisier adaugat cu succes.', 'success', 3000);
            if (data.ap_patientId) {
                this.edit.getPatientFiles(data.ap_patientId);
            }
        });
    }

    public customPatientDisplay = (row: any): string => {
        return row ? row.lastName + ' ' + row.firstName + (row.cnp ? (' - ' + row.cnp.substring(0, 7) + '...') : '') : null;
    }


    onViewClick = (ev: any) => {
        this.proxy.file.view(ev.row.data.id).then(() => { notify('Deschiderea fisierului a reusit', 'success', 3000); }, err => { notify(err.message, 'error', 3000); });
    }

    onDownloadClick = (ev: any) => {
        this.proxy.file.download(ev.row.data.id).then(() => { notify('Descarcarea fisierului a reusit', 'success', 3000); }, err => { notify(err.message, 'error', 3000); });
    }


}
